import React, { useEffect, useState } from "react";
import BreadCrumbComp from "../../../components/breadCrumb";
import { icons } from "../../../constants";
import { useNavigate } from "react-router-dom";
import VerificationModal from "../../../components/modals/verificationModal";
import LaddaButton from "../../../components/buttons/laddaButton";
import { useSelector } from "react-redux";
import { canManageInternationalSuppliers } from "../../../constants/supplierRoles";
import {
  callApiAsync,
  getInternationalSuppliers,
  deleteInternationalSuppliers,
  getProductsBySupplier,
  deleteSuppliersProduct,
  addOrUpdateInternationalSuppliersProduct
} from "../../../services/apiService";
import ToastNotification from "../../../components/toastNotification";
import ExpandableTable from "../../../components/tables/expandableTable";
import IconButtonTable from "../../../components/buttons/iconButton";
import CreateProductModal from "../createProductModal";
import { formatCustomDate } from "../../../services/dateService";
import { supplierType } from "../../../constants/enums";

const InternationalSuppliers = () => {
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [openVerification, setOpenVerification] = useState(false);
  const [openProductVerification, setOpenProductVerification] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [parentSelected, setParentSelected] = useState({});
  const [childSelected, setChildSelected] = useState({});
  const [deleteCount, setDeleteCount] = useState(0);
  const [showToast, setShowToast] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    severity: "success",
    summary: "",
    detail: ""
  });

  const navigate = useNavigate();
  const userData = useSelector((state) => state.userData.userData);

  const isSupplierManagment = canManageInternationalSuppliers(userData.roleList);

  const columns = [
    { field: "supplier_name", header: "Nombre del Proveedor" },
    { field: "supplier_id", header: "ID" },
    { field: "country", header: "País de Procedencia" },
    { field: "product_name", header: "Producto" },
    { field: "invima_register", header: "Registro Invima" },
    { field: "expire_date", header: "Fecha de Vencimiento" },
    { field: "importer_name", header: "Nombre del Importador" },
    { field: "health_register_holder", header: "Titular del Registro Invima" }

  ];

  const actionButtons = (rowData, type) => {
    if (type === "parent") {
      return (
        <div className="HContainer p-gap-2">
          {isSupplierManagment && (
            <IconButtonTable
              icon={icons.addPlus}
              background="#6A6AD80D"
              iconSize="18px"
              onClick={() => {
                setModalOpen(true);
                setParentSelected({
              ...rowData,
              supplier_type: rowData.supplier_type 
              });
                }}
              tootip="Agregar Producto/Dispositivo"
            />
          )}
          <IconButtonTable
            icon={icons.linkBlue}
            background="#6A6AD80D"
            iconSize="16px"
            onClick={() => {
              if (rowData.financial_statement_url) {
                window.open(rowData.financial_statement_url, "_blank");
              }
            }}
            tootip="Estado Financiero"
          />
          <IconButtonTable
            icon={!isSupplierManagment ? icons.eye : icons.editBlue}
            background="#6A6AD80D"
            iconSize="18px"
            onClick={() => {
              navigate("/suppliers/international_suppliers/create_new", {
                state: { data: rowData }
              });
            }}
            tootip={!isSupplierManagment ? "Detalles" : "Editar"}
          />
          {isSupplierManagment && (
            <IconButtonTable
              icon={icons.redTrash}
              background="#6A6AD80D"
              iconSize="18px"
              onClick={() => {
                setParentSelected(rowData);
                handleRemove(rowData);
              }}
              tootip="Eliminar"
            />
          )}
        </div>
      );
    }

    if (type === "child") {
      return (
        <div className="HContainer j-end">
          <IconButtonTable
            icon={!isSupplierManagment ? icons.eye : icons.editBlue}
            background="#6A6AD80D"
            iconSize="18px"
            onClick={() => {
            setModalOpen(true);
            setChildSelected(rowData);
            setParentSelected({
             ...rowData?.parentData, 
            supplier_type: supplierType.international
            });
            }}
            tootip={!isSupplierManagment ? "Detalles" : "Editar"}
          />
          {isSupplierManagment && (
            <IconButtonTable
              icon={icons.redTrash}
              background="#6A6AD80D"
              iconSize="18px"
              onClick={() => {
                setChildSelected(rowData);
                handleProductRemove();
              }}
              tootip="Eliminar"
            />
          )}
        </div>
      );
    }
  };

const getTableData = async () => {
  await callApiAsync(
    () => getInternationalSuppliers(),
    (data) => {
      const enrichedData = data.map((item) => ({
        ...item,
        supplier_type: supplierType.international
      }));
      setTableData(enrichedData); 
      setFilteredTableData([]);
      setSelectedData(null);
    }
  );
};

  const handleRemove = async (row) => {
    await callApiAsync(
      () => getProductsBySupplier(row.id, supplierType.international),
      (data) => {
        setDeleteCount(data.length);
        setOpenVerification(true);
      }
    );
  };

  const handleProductRemove = () => {
    setOpenProductVerification(true);
  };

  const handleRemoveConfirmed = async () => {
    await callApiAsync(
      () => deleteInternationalSuppliers({ id: parentSelected.id }),
      () => {
        getTableData();
        setParentSelected({});
        setOpenVerification(false);
        setToastConfig({
          severity: "success",
          summary: "Acción realizada",
          detail: "Se eliminó el proveedor."
        });
        setShowToast(true);
      }
    );
  };

  const handleRemoveProductConfirmed = async () => {
    await callApiAsync(
      () => deleteSuppliersProduct({ id: childSelected.id }),
      () => {
        getTableData();
        setChildSelected({});
        setOpenProductVerification(false);
        setToastConfig({
          severity: "success",
          summary: "Acción realizada",
          detail: "Producto eliminado."
        });
        setShowToast(true);
      }
    );
  };

  const handleCreateProduct = async (data) => {
    await callApiAsync(
      () => addOrUpdateInternationalSuppliersProduct(data),
      () => {
        getTableData();
      }
    );
  };

  useEffect(() => {
    getTableData();
  }, []);

  return (
    <div>
      <BreadCrumbComp />
      <div className="searchTitle  HContainer j-space-between align-center">
        <h1>PROVEEDOR FARMACÉUTICO INTERNACIONAL</h1>
        {isSupplierManagment && (
          <LaddaButton
            variant="contained"
            height="32px"
            onClick={() =>
              navigate("/suppliers/international_suppliers/create_new", {
                state: { data: { id: 0 } }
              })
            }
          >
            <div className="IHContainer align-center">
              <img
                className="btn-icon"
                src={icons.plusIcon}
                alt="icon"
                style={{ marginRight: "10px" }}
              />
              <p className="button_text">Crear Proveedor Farmacéutico Internacional</p>
            </div>
          </LaddaButton>
        )}
      </div>

      <ExpandableTable
        data={tableData}
        columns={columns}
        globalFilterFields={[
          "supplier_name",
          "country",
          "supplier_id",
          "product_name",
          "invima_register"
        ]}
        actionButtons={actionButtons}
      />

      <CreateProductModal
        open={modalOpen}
        handleClose={() => {
          setModalOpen(false);
          setParentSelected({});
          setChildSelected({});
        }}
        onSubmit={handleCreateProduct}
        initialData={childSelected}
        parentSelected={parentSelected}
        canManage={isSupplierManagment}
      />

      <VerificationModal
        open={openVerification}
        handleClose={() => {
          setOpenVerification(false);
          setParentSelected({});
        }}
        alertText={`¿Estás seguro de eliminar este proveedor? ${
          deleteCount > 0 ? `Tiene ${deleteCount} productos asociados.` : ""
        }`}
        onConfirm={handleRemoveConfirmed}
      />

      <VerificationModal
        open={openProductVerification}
        handleClose={() => {
          setOpenProductVerification(false);
          setChildSelected({});
        }}
        alertText="¿Estás seguro de eliminar este producto?"
        onConfirm={handleRemoveProductConfirmed}
      />

      <ToastNotification
        severity={toastConfig.severity}
        summary={toastConfig.summary}
        detail={toastConfig.detail}
        showToast={showToast}
        setShowToast={setShowToast}
        position="top-right"
      />
    </div>
  );
};

export default InternationalSuppliers;
